var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{attrs:{"src":require(`@/${_vm.getImage}`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }